////////////////////////////////////////////////////////////
//                                                          //
//  Program: CreditorList.jsx                              //
//  Application: Misc                                      //
//  Option: Manage Creditor/Lender profiles                //
//                                                          //
////////////////////////////////////////////////////////////

// Lives alongside the Credentials module (top navbar, next to "Credentials")
// rather than under the Misc Setup / Financial Attributes sidebar — Add now
// opens its own page (CreditorForm.jsx) instead of a modal, and Save lands
// on that same creditor in view mode, per the client's requested flow.
// Table wrapper/classes mirror UnitsAvailability.jsx (.scrolling-carousel
// allpanding > .dashboardRightcard > ReactDatatable) for visual consistency
// with the rest of the app's list pages.

import React, { Component } from "react";
import { Container, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactDatatable from "@ashvin27/react-datatable";
import Alerts from "../common/Alerts";
import deleteicon from "../../assets/images/delete.svg";
import modaldeleteicon from "./../../assets/images/delete.svg";
import CreditorService from "../../services/CreditorService";
import pluswIcon from "./../../assets/images/plus.svg";
import NoData from "../common/NoData";

export class CreditorList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slug: "",
      isSubmit: false,
      deleteCreditorModal: false,
      creditorList: [],
      creditorListTotal: 0,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      // creditor-list has no server-side pagination/sort support (getAllCreditors
      // always returns the full active set), so dynamic is left off — the table
      // paginates/sorts the full records array on the client.
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      extraButtons: [],
      columns: [],
    };
  }

  componentDidMount() {
    this.buildColumns();
    this.getCreditorData();
  }

  buildColumns() {
    let columns = [
      {
        key: "name",
        text: "Name",
        className: "name",
        sortable: true,
        cell: (record) => {
          // The backend's creditor-show endpoint is gated on "creditors-list"
          // (see routes/api.php), not "creditors-update" — gate the link the
          // same way, or a user with list-only access gets a dead-looking
          // name here instead of a working link into the view page.
          return global.userPermissions.checkPermission("creditors-list") ? (
            <Link to={"/creditors/view/" + record.slug}>{record.name}</Link>
          ) : (
            record.name
          );
        },
      },
      {
        key: "email",
        text: "Email",
        className: "email",
        sortable: true,
        cell: (record) => record.email || "",
      },
      {
        key: "phone",
        text: "Phone",
        className: "phone",
        sortable: true,
        cell: (record) => record.phone || "",
      },
      {
        key: "status_id",
        text: "Status",
        className: "status_id",
        sortable: true,
        cell: (record) => (record.status_id === 1 ? <b className="active"></b> : <b></b>),
      },
    ];

    if (global.userPermissions.checkPermission("creditors-delete")) {
      columns.push({
        key: "action",
        text: "Action",
        className: "action text-center",
        sortable: false,
        cell: (record) => (
          <div className="btn-icon-list d-block text-center">
            <img
              src={deleteicon}
              alt="Delete"
              onClick={() => this.openDeleteCreditorModal(record.slug)}
              className="hand-cursor"
            />
          </div>
        ),
      });
    }

    this.setState({ columns: columns });
  }

  async getCreditorData() {
    this.setState({ showSpinner: true, loading: true });
    let creditorList = [];
    let res = await CreditorService.getCreditors();
    if (global.successStatus.includes(res.status)) {
      creditorList = res.data ? res.data : [];
    }
    this.setState({
      creditorList: creditorList,
      creditorListTotal: creditorList.length,
      showSpinner: false,
      loading: false,
    });
  }

  deleteCreditor = async (slug) => {
    this.setState({ showSpinner: true, isSubmit: true });
    let res = await CreditorService.deleteCreditor(slug);
    if (global.successStatus.includes(res.status)) {
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message || "Success",
      });
      this.closeDeleteCreditorModal();
      this.getCreditorData();
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data ? res.data.errorCode || "Error!" : "Error!",
        alertModalMessage: res.data ? res.data.errorMessage || res.data.message : "Error!",
      });
    }
    this.setState({ showSpinner: false, isSubmit: false });
    setTimeout(() => this.setState({ showAlertModal: false }), global.alert_close_time);
  };

  openDeleteCreditorModal = (slug) => {
    this.setState({ deleteCreditorModal: true, slug: slug });
  };

  closeDeleteCreditorModal = () => {
    this.setState({ deleteCreditorModal: false, slug: "" });
  };

  // No server round-trip needed (see config note above) — ReactDatatable
  // already re-sorts/re-paginates the records it was given on its own.
  tableChangeHandler = () => {};

  getTitle() {
    return "Creditors";
  }

  render() {
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0 pd-lg-l-15 pd-xs-l-0">
                <div className="col-md-12">
                  <div className="col-md-12 mg-t-20 mg-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>{this.getTitle()}</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        {global.userPermissions.checkPermission("creditors-add") && (
                          <Link to={"/creditors/add"}>
                            <button type="button" className="btn-success-outline-small ml-3">
                              <img src={pluswIcon} alt="add" /> Add
                            </button>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="scrolling-carousel allpanding">
                    <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                      <div className="col-md-12 pd-l--30 pd-r-30">
                        <Alerts
                          show={this.state.showAlertModal}
                          type={this.state.alertModalType}
                          title={this.state.alertModalTitle}
                          message={this.state.alertModalMessage}
                        />
                      </div>

                      {this.state.creditorListTotal > 0 ? (
                        // wh-creditor-list scopes the no-underline rule for the Name links (see custom.scss)
                        <div className="mg-t-18 brandList row d-block wh-creditor-list">
                          <div className="pd-lg-l-0 pd-lg-r-0 pd-xs-l-25 pd-xs-r-15">
                            <ReactDatatable
                              className="table no-wrap mg-b-30 pd-b-2 table_last_row"
                              config={this.state.config}
                              records={this.state.creditorList}
                              columns={this.state.columns}
                              extraButtons={this.state.extraButtons}
                              total_record={this.state.creditorListTotal}
                              onChange={this.tableChangeHandler}
                            />
                          </div>
                        </div>
                      ) : (
                        <NoData msg={global.commonMessages.checkMessage("CREDITOR")} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* Delete Creditor modal */}
        <Modal show={this.state.deleteCreditorModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <span className="welcomeClose" onClick={() => this.closeDeleteCreditorModal()}>
                {global.closee}
              </span>
              <img src={modaldeleteicon} alt="modal-delete-icon" />
              <h3>Delete this Creditor?</h3>
              <p>
                Units still referencing this creditor keep their existing link — reassign
                them first if needed. This cannot be undone.
              </p>
              <div className="d-flex justify-content-center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeDeleteCreditorModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteCreditor(this.state.slug)}
                  disabled={this.state.isSubmit}
                >
                  {this.state.isSubmit ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default CreditorList;
